import storageUtils from '../../util/storageUtils'
import storageKey from '../../constants/storageKey'

const loader = {
  actions: {
    loadLayoutFromLocal (context) {
      const loginId = context.rootState.account.loginId || '_anonymous'
      // 加载选项卡
      let mainTabOptions = storageUtils.getItem(loginId, storageKey.MAIN_TAB_OPTIONS)
      context.commit('setMainTabs', mainTabOptions)
    },
    loadConfigFromLocal (context) {
      const loginId = context.rootState.account.loginId || '_anonymous'
      // 加载表格配置
      let gridConfig = storageUtils.getItem(loginId, storageKey.TEMPLATE_GRID_CONFIG)
      if (gridConfig) {
        context.commit('setGridConfig', gridConfig)
      }
    }
  }
}

export default loader
